import React, { ChangeEvent, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Main, DivInputContainer, Input, TagError } from '../../styles';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 30vw;
`;

interface IName {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
}
const MothersNameValidation: React.FC<IName> = ({ name, setName }) => {
  const { msg } = useSelector((state: ApplicationState) => ({
    msg: state.auth.status,
  }));
  const [errorContact, setErrorContact] = useState<boolean>(false);
  useEffect(() => {
    setErrorContact(msg === 'Nome diferente do cadastrado');
  }, [msg]);
  return (
    <Wrapper>
      <Main>
        <>
          <h1>Autenticação</h1>
          <p>
            Insira os dois primeiros caracteres do nome da mãe para continuar
          </p>
        </>
      </Main>
      <DivInputContainer error={errorContact}>
        <Input
          value={name}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setName(e.target.value);
          }}
          maxLength={2}
        />
        {errorContact && <TagError>Nome inserido incorretamente</TagError>}
      </DivInputContainer>
    </Wrapper>
  );
};

export default MothersNameValidation;
